/**
 * Hydrates a brand's per-vehicle ownership answers for the car form (supportsVehicleOwnershipDetails).
 *
 * "Is the vehicle solely owned by, and registered to, the applicant?" is a Yes/No question the agent
 * must answer (#36127). A stored answer always wins; an unanswered car takes `unansweredDefault`:
 * `null` on an offer, so the question shows blank and validation requires it, and `true` on a policy,
 * so bound and migrated vehicles aren't blocked behind a question nobody was asked.
 *
 * jointOwner hydrates to '' (not null) so the Joint Owner select renders a blank input with its label
 * shrunk, matching the interested-party "Relationship" select.
 */
export const hydrateVehicleOwnershipForForm = (cars, { unansweredDefault }) =>
  (cars ?? []).map((car) => ({
    ...car,
    solelyOwnedByApplicant: car?.solelyOwnedByApplicant ?? unansweredDefault,
    jointOwner: car?.jointOwner ?? ''
  }));
